/* eslint-disable no-void */
import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import styles from './ApprovalPanel.module.scss';

const { Description, SubTitle } = vp;

type ApprovalPanelProps = {
  title: string;
  description: string;
};

type FC = FunctionComponent<ApprovalPanelProps>;

const ApprovalPanel: FC = ({ title, description }: ApprovalPanelProps) => (
  <div className={styles.ContainerPanel}>
    <SubTitle subTitle={title} />
    <Description size="lg" hasNoPadding>
      {description}
    </Description>
  </div>
);

export default ApprovalPanel;
